export default __webpack_public_path__ + "static/media/sass.0c9ba2c6.png";